import React, { useState } from 'react';
import { CircleHelp } from 'lucide-react';
import StateLookup from './state_lookup.json'

import './style.css';

const ExpensesDatapoint = ({ datapoint, county_name, state, zip }) => {
    const [isHovering, setIsHovering] = useState(false);

    // Use state to find the object in StateLookup array that has that as a value for short_name
    const state_name = StateLookup.find(obj => obj.name_short === state)?.name_long || state;

    const format_rank = (rank) => {
        if (rank === null) return null;

        const total_counties = 3144;

        // Handle 1-10 specifically
        if (rank <= 10) {
            if (rank === 1) return "Highest in the US";
            if (rank === 2) return "2nd Highest in the US";
            if (rank === 3) return "3rd Highest in the US";
            return `${rank}th Highest in the US`;
        }

        // Handle top 20, 50, 100
        if (rank <= 20) return "Top 20 in the US";
        if (rank <= 50) return "Top 50 in the US";
        if (rank <= 100) return "Top 100 in the US";

        // Calculate percentage
        const percentile = (rank / total_counties) * 100;

        if (percentile <= 50) {
            return `Top ${Math.round(percentile)}% in the US`;
        } else {
            return `Bottom ${Math.round(100 - percentile)}% in the US`;
        }
    };

    return (
        <div className="expense-data-item">
            {datapoint.about && (
                <div
                    className="info-icon"
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                >
                    <CircleHelp fill="var(--white)" size={32} />
                    {isHovering && (
                        <div className="tooltip">
                            {datapoint.about}
                        </div>
                    )}
                </div>
            )}
            <div className="location">
                {datapoint.geo === 'fips' && county_name}
                {datapoint.geo === 'state' && state_name}
                {datapoint.geo === 'zip' && zip}
            </div>
            <div className="expense-data-item-header">

                <div className="title text-align-center">{datapoint.title}</div>
            </div>
            <div className="expense-data-item-content">

                <div className="value text-align-center">
                    {datapoint.value_type === 'percentage' && `${Math.ceil(datapoint.value * 100)}%`}
                    {datapoint.value_type === 'currency' && new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        maximumFractionDigits: 0
                    }).format(datapoint.value)}
                    {datapoint.value_type === 'boolean' && (datapoint.value ? 'Yes' : 'No')}
                    {datapoint.value_type === 'rank' && format_rank(datapoint.value)}
                </div>
                {datapoint.subvalue && (
                    <div className="subvalue text-align-center">
                        {datapoint.subvalue_type === 'rank' && format_rank(datapoint.subvalue)}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExpensesDatapoint;
